import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';             // ✅ add this

import { JobsListComponent } from './jobs-list/jobs-list.component';
import { CreateJobComponent } from './create-job/create-job.component';
import { JobLogsComponent } from './job-logs/job-logs.component';
import { FormsModule } from '@angular/forms';
import { JobDetailsComponent } from './job-details/job-details.component';

@NgModule({
  declarations: [
    JobsListComponent,
    CreateJobComponent,
    JobLogsComponent,
    JobDetailsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule                                        // ✅ add this
  ]
})
export class JobsModule { }